/**
 * AAA IDP place of birth reducer
 * 
 */
import { DELETE, PLACE_OF_BIRTH, VALIDATE } from '../../actions/types';
export const initialState = {
  error: false,
  required: true,
  valid: true,
  value: ''
};
export default function (state = initialState, action) {
  switch (action.type) {
    case DELETE:
      return initialState;
    case PLACE_OF_BIRTH:
      {
        let {
          required
        } = state;
        const {
          value
        } = action;
        const valid = value === '' && required ? false : true;
        return {
          error: !valid,
          required,
          valid,
          value
        };
      }
    case VALIDATE:
      {
        const {
          value,
          required
        } = state;
        const valid = value === '' && required ? false : true;
        return {
          ...state,
          error: !valid,
          valid
        };
      }
    default:
      return state;
  }
}